var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRingOutline = function SvgRingOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48,87.5 C26.1847524,87.5 8.5,69.8152476 8.5,48 C8.5,26.1847524 26.1847524,8.5 48,8.5 C69.8152476,8.5 87.5,26.1847524 87.5,48 C87.5,69.8152476 69.8152476,87.5 48,87.5 Z M48,79.5 C65.3969696,79.5 79.5,65.3969696 79.5,48 C79.5,30.6030304 65.3969696,16.5 48,16.5 C30.6030304,16.5 16.5,30.6030304 16.5,48 C16.5,65.3969696 30.6030304,79.5 48,79.5 Z",
    fill: "#000000",
    fillRule: "evenodd"
  })));
};
export default SvgRingOutline;